import script from "./GoalMilestoneMobile.vue?vue&type=script&setup=true&lang=ts"
export * from "./GoalMilestoneMobile.vue?vue&type=script&setup=true&lang=ts"

import "./GoalMilestoneMobile.vue?vue&type=style&index=0&id=1d3ae286&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d3ae286"]])

export default __exports__